var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.084 14.8469C128.391 18.4218 128.628 57.0354 128.628 64.564C128.628 72.0926 128.391 110.706 128.084 114.281C126.13 116.795 124.002 119.168 121.715 121.384C119.494 123.664 117.121 125.792 114.613 127.752C96.0752 128.249 103.675 128.604 64.5877 128.604C25.5006 128.604 33.1002 128.249 14.5628 127.752C9.57362 123.773 5.04704 119.247 1.06821 114.257C0.760438 110.683 0.523682 72.0689 0.523682 64.5403C0.523682 57.0117 0.760438 18.3981 1.06821 14.8232C3.02804 12.3144 5.15576 9.94152 7.43672 7.72074C9.65197 5.434 12.0253 3.3059 14.5392 1.3522C33.0765 0.855032 25.4769 0.499908 64.564 0.499908C103.651 0.499908 96.0516 0.855032 114.589 1.3522C119.578 5.33103 124.105 9.85763 128.084 14.8469Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.218 64.5641C8.218 59.8291 8.21799 22.6123 8.54944 17.759L1.04453 14.847C0.736756 18.4219 0.5 57.0355 0.5 64.5641C0.5 72.0927 0.736756 110.706 1.04453 114.281L8.54944 111.369C8.21799 106.634 8.218 69.3701 8.218 64.5641Z",
    fill: "url(#paint0_radial_490_8841)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54935 17.7585C9.89881 16.1486 11.5087 14.5388 12.8582 13.1656C14.2076 11.7925 15.7465 10.3246 17.2854 8.99884L14.5391 1.35187C12.0252 3.30557 9.65187 5.43367 7.43663 7.7204C5.15566 9.94118 3.02795 12.3141 1.06812 14.8228L8.57303 17.7348L8.54935 17.7585Z",
    fill: "url(#paint1_radial_490_8841)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2858 8.99918H111.843L114.589 1.3522C96.0519 0.855032 103.652 0.499908 64.5644 0.499908C25.4773 0.499908 33.0769 0.855032 14.5396 1.3522L17.2858 8.99918Z",
    fill: "url(#paint2_radial_490_8841)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.843 8.99884C113.382 10.3246 114.944 11.8635 116.246 13.1656C117.548 14.4677 119.229 16.1486 120.579 17.7585L128.084 14.8465C124.105 9.85729 119.578 5.3307 114.589 1.35187L111.843 8.99884Z",
    fill: "url(#paint3_radial_490_8841)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.579 17.759C120.91 22.6123 120.91 59.7581 120.91 64.5641C120.91 69.3701 120.91 106.516 120.579 111.369L128.084 114.281C128.391 110.706 128.628 72.0927 128.628 64.5641C128.628 57.0355 128.391 18.4219 128.084 14.847L120.579 17.759Z",
    fill: "url(#paint4_radial_490_8841)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.579 111.369C119.229 112.979 117.619 114.589 116.246 115.962C114.873 117.335 113.382 118.803 111.843 120.129L114.589 127.776C117.098 125.816 119.471 123.688 121.692 121.407C123.978 119.192 126.106 116.819 128.06 114.305L120.555 111.393L120.579 111.369Z",
    fill: "url(#paint5_radial_490_8841)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.843 120.128H17.2858L14.5396 127.775C33.0769 128.272 25.4773 128.627 64.5644 128.627C103.652 128.627 96.0519 128.272 114.589 127.775L111.843 120.128Z",
    fill: "url(#paint6_radial_490_8841)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2854 120.129C15.7465 118.803 14.184 117.264 12.8582 115.962C11.5324 114.66 9.89881 112.979 8.54935 111.369L1.04443 114.281C5.02326 119.27 9.54984 123.797 14.5391 127.776L17.2854 120.129Z",
    fill: "url(#paint7_radial_490_8841)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5644 126C15.3918 126 17.2148 123.372 17.2148 120.128L14.4685 127.775C33.0059 128.272 25.4063 128.627 64.4934 128.627C103.581 128.627 95.9809 128.272 114.518 127.775L111.772 120.128C111.772 123.372 113.666 126 64.4224 126H64.5644Z",
    fill: "url(#paint8_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5391 1.35187C14.9982 3.21529 14.9686 5.16567 14.4532 7.0143C13.9377 8.86294 12.9539 10.5473 11.5968 11.9043C10.2398 13.2613 8.5555 14.2452 6.70687 14.7606C4.85823 15.276 2.90785 15.3056 1.04443 14.8465L8.54935 17.7585C9.89881 16.1486 11.5087 14.5388 12.8582 13.1656C14.2076 11.7925 15.7465 10.3246 17.2854 8.99884L14.5391 1.35187Z",
    fill: "url(#paint9_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.589 1.35187C114.13 3.21529 114.16 5.16567 114.675 7.0143C115.19 8.86294 116.174 10.5473 117.531 11.9043C118.888 13.2613 120.573 14.2452 122.421 14.7606C124.27 15.276 126.22 15.3056 128.084 14.8465L120.579 17.7585C119.229 16.1486 117.619 14.5388 116.246 13.1656C114.873 11.7925 113.382 10.3246 111.843 8.99884L114.589 1.35187Z",
    fill: "url(#paint10_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.589 127.776C114.13 125.913 114.16 123.962 114.675 122.113C115.19 120.265 116.174 118.581 117.531 117.223C118.888 115.866 120.573 114.883 122.421 114.367C124.27 113.852 126.22 113.822 128.084 114.281L120.579 111.369C119.229 112.979 117.619 114.589 116.246 115.962C114.873 117.335 113.382 118.803 111.843 120.129L114.589 127.776Z",
    fill: "url(#paint11_radial_490_8841)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8583 115.962C14.1841 117.264 15.7466 118.803 17.2855 120.128H111.843C113.382 118.803 114.944 117.264 116.246 115.962C117.548 114.66 119.229 112.979 120.579 111.369C120.91 106.634 120.91 69.3696 120.91 64.5636C120.91 59.7576 120.91 22.6118 120.579 17.7585C119.229 16.1486 117.619 14.5387 116.246 13.1656C114.873 11.7924 113.382 10.3246 111.843 8.99881H17.2855C15.7466 10.3246 14.1841 11.8635 12.8583 13.1656C11.5325 14.4677 9.89893 16.1486 8.54946 17.7585C8.21802 22.6118 8.21802 59.7576 8.21802 64.5636C8.21802 69.3696 8.21802 106.515 8.54946 111.369C9.89893 112.979 11.5088 114.588 12.8583 115.962Z",
    fill: "#B3B3B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8583 115.962C14.1841 117.264 15.7466 118.803 17.2855 120.128H111.843C113.382 118.803 114.944 117.264 116.246 115.962C117.548 114.66 119.229 112.979 120.579 111.369C120.91 106.634 120.91 69.3696 120.91 64.5636C120.91 59.7576 120.91 22.6118 120.579 17.7585C119.229 16.1486 117.619 14.5387 116.246 13.1656C114.873 11.7924 113.382 10.3246 111.843 8.99881H17.2855C15.7466 10.3246 14.1841 11.8635 12.8583 13.1656C11.5325 14.4677 9.89893 16.1486 8.54946 17.7585C8.21802 22.6118 8.21802 59.7576 8.21802 64.5636C8.21802 69.3696 8.21802 106.515 8.54946 111.369C9.89893 112.979 11.5088 114.588 12.8583 115.962Z",
    fill: "url(#paint12_linear_490_8841)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54946 111.369L64.5641 64.5641L8.54946 17.7589C8.21802 22.6123 8.21802 59.7581 8.21802 64.5641C8.21802 69.3701 8.21802 106.516 8.54946 111.369Z",
    fill: "url(#paint13_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2856 8.99881L64.5642 64.5636L111.843 8.99881H17.2856Z",
    fill: "url(#paint14_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.579 17.7589L64.5642 64.5641L120.579 111.369C120.91 106.634 120.91 69.3701 120.91 64.5641C120.91 59.7581 120.91 22.6123 120.579 17.7589Z",
    fill: "url(#paint15_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.843 120.129L64.5642 64.5641L17.2856 120.129H111.843Z",
    fill: "url(#paint16_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8962 105.45L23.062 105.592H106.066L106.208 105.45C106.208 104.456 106.208 103.485 106.208 102.515C106.208 97.6613 106.208 92.7843 106.208 87.9073C106.208 80.142 106.208 72.3529 106.208 64.5639C106.208 56.7749 106.208 49.0096 106.208 41.2206C106.208 36.3435 106.208 31.4902 106.208 26.6132C106.208 25.6662 106.208 24.6718 106.208 23.6775L106.066 23.5355H23.062L22.8962 23.6775V26.6132C22.8962 31.4902 22.8962 36.3435 22.8962 41.2206C22.8962 49.0096 22.8962 56.7749 22.8962 64.5639C22.8962 72.3529 22.8962 80.142 22.8962 87.9073C22.8962 92.7843 22.8962 97.6613 22.8962 102.515V105.45Z",
    fill: "url(#paint17_radial_490_8841)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.579 111.369C119.23 112.979 117.62 114.589 116.246 115.962C114.873 117.335 113.382 118.803 111.843 120.129H55.7573L111.204 120.745L111.748 121.1L114.376 127.232C113.761 125.124 113.121 123.017 112.482 120.934L112.624 120.271C115.157 117.525 117.785 114.826 120.461 112.222L121.1 112.056L126.119 113.524L121.384 111.346L121.052 110.801C121.36 101.331 121.36 27.9394 121.052 18.4694L121.384 17.9249L125.835 15.7468L121.1 17.2147L120.461 17.0489C118.093 14.6815 115.726 12.4797 113.216 10.3016C114.281 11.2959 115.299 12.314 116.199 13.2136C117.572 14.5868 119.182 16.1966 120.532 17.8065C120.863 22.6599 120.863 59.8057 120.863 64.6116C120.863 69.4176 120.863 106.563 120.532 111.417L120.579 111.369Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54978 17.7585L64.5644 64.5636L17.2148 8.99881C15.6759 10.3246 14.1134 11.8635 12.7876 13.1656C11.4618 14.4677 9.82822 16.1486 8.47876 17.7585H8.54978Z",
    fill: "url(#paint18_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.579 17.7585L64.5642 64.5636L111.914 8.99881C113.453 10.3246 115.015 11.8635 116.317 13.1656C117.619 14.4677 119.3 16.1486 120.65 17.7585H120.579Z",
    fill: "url(#paint19_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54978 111.369L64.5644 64.5641L17.2148 120.129C15.6759 118.803 14.1134 117.264 12.7876 115.962C11.4618 114.66 9.82822 112.979 8.47876 111.369H8.54978Z",
    fill: "url(#paint20_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.579 111.369L64.5642 64.5641L111.914 120.129C113.453 118.803 115.015 117.264 116.317 115.962C117.619 114.66 119.3 112.979 120.65 111.369H120.579Z",
    fill: "url(#paint21_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1157 8.99863C62.0312 8.28838 55.2129 2.70112 59.6401 0.523041C26.0929 0.523041 32.2483 0.878159 14.5396 1.35166L17.2858 8.99863H68.1157Z",
    fill: "url(#paint22_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5396 1.37588C14.9657 1.94408 14.1134 2.3939 64.5644 2.3939C115.015 2.3939 114.282 1.94408 114.566 1.37588C96.052 0.855037 103.652 0.499908 64.5644 0.499908C25.4773 0.499908 33.0769 0.855032 14.5396 1.3522V1.37588Z",
    fill: "url(#paint23_radial_490_8841)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2856 8.99944H79.6687L17.9722 8.12347L17.4276 7.79202C16.5043 5.77966 15.6757 3.98038 14.7761 1.96802C15.3206 4.09875 15.7231 6.11111 16.2676 8.24185L16.1255 8.90474C13.7546 11.6769 11.2167 14.3018 8.52591 16.7648L7.86302 16.9068C5.82698 16.2913 3.90933 15.7941 1.87329 15.1786L7.48423 17.8065L7.83934 18.3747C7.69729 27.8446 7.67361 101.402 7.83934 110.706L7.50789 111.275C6.32415 111.914 5.25879 112.553 4.05137 113.192C5.37716 112.837 6.63193 112.577 7.95772 112.245L8.59693 112.435C11.1775 115.015 13.9711 117.714 16.4806 120.295L16.6701 120.934C16.4096 121.976 16.2439 122.804 15.9835 123.87C16.457 122.875 17.0015 122.07 17.475 121.1L18.0432 120.768L52.8689 120.2H17.3566C15.8178 118.874 14.2552 117.335 12.9294 116.033C11.6036 114.731 9.97007 113.05 8.62061 111.44C8.28916 106.705 8.28916 69.4412 8.28916 64.6353C8.28916 59.8293 8.28916 22.6835 8.62061 17.8301C9.97007 16.2203 11.58 14.6104 12.9294 13.2372C14.2789 11.8641 15.8178 10.3963 17.3566 9.07046L17.2856 8.99944Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28906 93.7073L92.9976 8.99881H37.196L8.28906 37.9294C8.28906 49.4117 8.28906 61.912 8.28906 64.5636C8.28906 67.2152 8.28906 81.6095 8.28906 93.7073Z",
    fill: "url(#paint24_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.962 12.8818L12.8582 115.962C14.1839 117.264 15.7465 118.803 17.2854 120.129H33.2422L120.839 32.6503C120.839 25.5478 120.721 19.5107 120.602 17.7588C119.253 16.1489 117.643 14.539 116.27 13.1659L115.986 12.8818H115.962Z",
    fill: "url(#paint25_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3611 109.83C13.4027 110.99 14.5155 112.198 15.6045 113.216C16.6936 114.234 17.6642 115.276 18.7533 116.246H110.375C111.464 115.276 112.482 114.234 113.524 113.216C114.565 112.198 115.725 110.99 116.767 109.83C116.885 107.463 116.767 105.095 116.885 102.728C116.885 97.8351 116.885 92.9344 116.885 88.0258C116.885 80.2368 116.885 72.4241 116.885 64.6351C116.885 56.8461 116.885 49.0334 116.885 41.2444C116.885 36.3516 116.885 31.4509 116.885 26.5423C116.885 24.1748 116.885 21.8073 116.767 19.4399C115.725 18.2798 114.613 17.0724 113.524 16.0544C112.435 15.0363 111.464 13.9947 110.375 13.024H18.7533C17.6642 13.9947 16.6225 15.0363 15.6045 16.0544C14.5865 17.0724 13.4027 18.2798 12.3611 19.4399C12.2427 21.8073 12.361 24.1748 12.2427 26.5423C12.2427 31.4351 12.2427 36.3358 12.2427 41.2444C12.2427 49.0334 12.2427 56.8461 12.2427 64.6351C12.2427 72.4241 12.2427 80.2368 12.2427 88.0258C12.2427 92.9186 12.2427 97.8193 12.2427 102.728C12.2427 105.095 12.2427 107.463 12.3611 109.83Z",
    fill: "url(#paint26_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.581 20.8839L110.422 12.9292H18.7532L21.5468 20.9313L107.581 20.8839Z",
    fill: "url(#paint27_linear_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.581 108.243L110.422 116.198H18.7532L21.5468 108.196L107.581 108.243Z",
    fill: "url(#paint28_linear_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1027 107.131V21.9017L12.3611 19.2028C12.2427 21.5703 12.361 23.9378 12.2427 26.3052C12.2427 31.198 12.2427 36.0987 12.2427 41.0073C12.2427 48.7963 12.2427 56.609 12.2427 64.398C12.2427 72.187 12.2427 79.9997 12.2427 87.7887C12.2427 92.6815 12.2427 97.5822 12.2427 102.491C12.2427 104.858 12.2427 107.226 12.3611 109.593L20.1027 106.894V107.131Z",
    fill: "url(#paint29_radial_490_8841)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.002 107.131V21.9017L116.744 19.2028C116.862 21.5703 116.744 23.9378 116.862 26.3052C116.862 31.198 116.862 36.0987 116.862 41.0073C116.862 48.7963 116.862 56.609 116.862 64.398C116.862 72.187 116.862 79.9997 116.862 87.7887C116.862 92.6815 116.862 97.5822 116.862 102.491C116.862 104.858 116.862 107.226 116.744 109.593L109.002 107.131Z",
    fill: "url(#paint30_linear_490_8841)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.525 64.5641C117.525 72.3768 117.525 80.1737 117.525 87.9548C117.525 92.8476 117.525 97.7483 117.525 102.657C117.525 105.024 117.525 107.392 117.525 109.759V109.925V110.067C116.459 111.227 115.347 112.435 114.234 113.453C113.121 114.471 112.174 115.536 111.085 116.53H110.943H18.564H18.422C17.3329 115.536 16.2913 114.494 15.2732 113.453C14.2552 112.411 13.0478 111.227 11.9824 110.067V109.925V109.759C11.9824 107.392 11.9824 105.024 11.9824 102.657C11.9824 97.7641 11.9824 92.8634 11.9824 87.9548C11.9824 80.1579 11.9824 72.361 11.9824 64.5641C11.9824 56.7751 11.9824 48.9624 11.9824 41.1734C11.9824 36.2806 11.9824 31.3799 11.9824 26.4713C11.9824 24.1038 11.9824 21.7363 11.9824 19.3689V19.2031V19.0611C13.0478 17.901 14.1605 16.6936 15.2732 15.6756C16.386 14.6576 17.3329 13.5922 18.422 12.6215L18.564 12.4795H110.564L110.706 12.6215C111.795 13.5922 112.837 14.6339 113.855 15.6756C114.873 16.7173 116.081 17.901 117.146 19.0611V19.2031V19.3689C117.146 21.7363 117.146 24.1038 117.146 26.4713C117.146 31.3641 117.146 36.2648 117.146 41.1734C117.146 48.9624 117.146 56.7751 117.146 64.5641H117.525ZM12.3612 109.83C13.4029 110.99 14.5156 112.198 15.6047 113.216C16.6937 114.234 17.6644 115.276 18.7534 116.246H110.375C111.464 115.276 112.482 114.234 113.524 113.216C114.565 112.198 115.725 110.99 116.767 109.83C116.886 107.463 116.767 105.095 116.886 102.728C116.886 97.8351 116.886 92.9344 116.886 88.0258C116.886 80.2368 116.886 72.4241 116.886 64.6351C116.886 56.8461 116.886 49.0334 116.886 41.2444C116.886 36.3516 116.886 31.4509 116.886 26.5423C116.886 24.1748 116.886 21.8074 116.767 19.4399C115.725 18.2798 114.613 17.0724 113.524 16.0544C112.435 15.0364 111.464 13.9947 110.375 13.024H18.7534C17.6644 13.9947 16.6227 15.0364 15.6047 16.0544C14.5867 17.0724 13.4029 18.2798 12.3612 19.4399C12.2429 21.8074 12.3612 24.1748 12.2428 26.5423C12.2428 31.4351 12.2428 36.3358 12.2428 41.2444C12.2428 49.0334 12.2428 56.8461 12.2428 64.6351C12.2428 72.4241 12.2428 80.2368 12.2428 88.0258C12.2428 92.9186 12.2428 97.8193 12.2428 102.728C12.2428 105.095 12.2429 107.463 12.3612 109.83Z",
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_490_8841)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_490_8841)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8144 53.583H60.3529L61.9088 48.2845L68.4267 48.0742L69.9826 53.583H69.8144ZM53.078 74.8609C51.6903 71.3286 51.6903 67.7542 53.078 64.2219C54.2554 61.0681 56.8205 58.503 59.9744 57.1574C61.5303 56.5686 63.3385 56.1481 65.1047 56.1481C66.9129 56.1481 68.4688 56.5266 70.2349 57.1574C73.3888 58.545 75.7436 61.0681 77.1313 64.2219C78.519 67.7542 78.519 71.3286 77.1313 74.8609C75.7436 78.0148 73.3888 80.5799 70.2349 81.9255C66.9129 83.3132 63.3385 83.3132 60.0165 81.9255C56.7785 80.5378 54.2134 78.0148 53.078 74.8609ZM42.7754 53.583C41.2195 53.7933 40 55.1389 40 56.7368V82.346C40 84.1122 41.3877 85.4999 42.9857 85.4999H86.9293C88.6954 85.4999 90.0831 84.1122 90.0831 82.346V56.7368C90.0831 54.9707 88.6954 53.583 86.9293 53.583C86.7611 52.6158 86.7611 51.2281 86.1303 50.6394C85.9621 50.4291 85.5416 50.4291 85.121 50.4291H76.2483C74.8606 50.4291 74.8605 52.1953 74.6923 53.583H73.515L71.3282 45.8876C71.16 45.0886 70.5293 44.4999 69.7723 44.4999L60.8996 44.7101C59.8903 44.7101 59.3015 45.0886 58.9231 46.0978L56.7364 53.583H42.7754ZM70.9919 63.6332C64.8524 57.5358 54.8021 63.0445 56.4 71.4968C57.7877 79.1922 67.6277 81.3368 71.959 74.6507C74.3138 71.3286 73.9355 66.5768 70.9919 63.6332Z",
    fill: "#EDCBF8",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_490_8841",
    x: 32,
    y: 38.4999,
    width: 66.083,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.494118 0 0 0 0 0.0627451 0 0 0 0 0.831373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_490_8841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_490_8841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_490_8841",
    x: 22,
    y: 26.4999,
    width: 86.083,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_490_8841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_490_8841",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-10.2484 11.9587) scale(151.116 151.116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A83CF7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5514 -3.4778) scale(78.5767 78.5767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA8DF7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.5644 4.76138) scale(35.4886 35.4886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D46EF7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.221 -7.40782) scale(57.9086 57.9086)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAA5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B520F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.95 6.30037) scale(145.032 145.032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAA5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B520F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.433 71.7376) scale(72.2083 72.2083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD00DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2519 84.8054) scale(121.547 121.546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAA5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B520F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.6363 97.5432) scale(58.8556 58.8557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9A5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD00DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7861 161.346) scale(150.075 150.075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3698 11.3426) scale(33.6419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB7FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.114 18.3504) scale(42.8988 42.8988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB7FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.869 108.055) scale(33.5946 33.5946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB58DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_490_8841",
    x1: 116.104,
    y1: 116.104,
    x2: 13.024,
    y2: 13.0235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC6AF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B531F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7275 133.695) scale(146.168 146.168)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9496 -60.6288) scale(130.401 130.401)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA89F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.58 66.316) scale(147.684 147.684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA89F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6831 131.493) scale(137.361 137.361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA89F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.015 126.308) scale(136.201 136.201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.73918 0.688945) scale(112.526 112.526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CABFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000868"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.6903 69.3933) scale(147.897 147.897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CABFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000868"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-40.4097 158.435) scale(146.902 146.902)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CABFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000868"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.742 150.622) scale(135.846 135.846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CABFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000868"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.854 16.0537) scale(97.7296 97.7297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1943 -11.0061) scale(124.743 124.743)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3427 8.73839) scale(108.952 108.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.4699 -25.8028) scale(157.082 157.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5628 11.5088) scale(213.618 213.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA89F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_490_8841",
    x1: 64.5876,
    y1: 20.8839,
    x2: 64.5876,
    y2: 12.8818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAB3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB58DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_490_8841",
    x1: 64.5876,
    y1: 116.245,
    x2: 64.5876,
    y2: 108.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3A70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_490_8841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5557 33.6918) scale(163.688 163.688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB58DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_490_8841",
    x1: 109.026,
    y1: 64.5637,
    x2: 117.028,
    y2: 64.5637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B3A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA7EF7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.e5acb0363f43e4b1aa5b0e49a48821d1.svg";
export { ForwardRef as ReactComponent };